const staticAssetsURL = () => {
    switch (process.env.REACT_APP_ENVIRONMENT) {
        case 'production':
        case 'PRODUCTION':
        case 'prod':
        case 'PROD':
            return 'https://assets.visiolending.com/';

        case 'staging':
        case 'stage':
        case 'STAGING':
        case 'STAGE':
            return 'https://assets-staging.visiolending.com/';

        default:
            return 'https://assets-dev.visiolending.com/';
    }
};

export default staticAssetsURL;
